import React, { useState } from "react";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import Grid from "@mui/material/Grid";
import { brandColors } from "../brandedComponent/BrandedColors";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import Cookies from "universal-cookie";
import { LifeSafer } from "../../_helpers/BrandConstants";
import PropTypes from "prop-types";

const ReadyInfo = ({
  handleUpdate,
  goToNextStep,
}) => {
  const { t } = useTranslation();
  const cookies = new Cookies();
  const brand = cookies.get("lsEnrollmentReferral") || LifeSafer;
  const enrolleeUser = JSON.parse(sessionStorage.getItem("enrolleeUser"));

  const [scheduleModal, setScheduleModal] = useState(false);

  const handleClose = () => {
    setScheduleModal(false);
  };

  const handleOpen = () => {
    setScheduleModal(true);
  };

  const handleScheduleOnlineClick=()=>{
    handleUpdate("Ready")
    goToNextStep();
  }


  return (
    <>
      <Grid container>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            // gap: { xs:0, sm:"10px" },
            gap: { xs: 0, md: "10px" },
            flexWrap: "wrap",
            flexDirection: { xs: "column-reverse", md: "row" },
            marginTop: 2,
          }}
        >
          <Button
            size="small"
            variant="contained"
            startIcon={<PhoneIphoneIcon />}
            sx={{
              height: 35,
              mb: 2,
              px: 2,
              width: "max-content",
              fontWeight: "bold",
            }}
            // component="a"
            onClick={handleOpen}
          >
            {t("outro.callNowButton")}
          </Button>

          <Button
            size="small"
            variant="contained"
            startIcon={<EventAvailableIcon />}
            onClick={handleScheduleOnlineClick}
            sx={{
              height: 35,
              width: 230,
              mb: 2,
              px: 2,
              fontWeight: "bold",
              backgroundColor: `${brandColors[brand].secondary}`,
            }}
          >
            {t("outro.scheduleOnlineButton")}
          </Button>

          <Dialog
            open={scheduleModal}
            disableEnforceFocus
            onClose={handleClose}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <DialogTitle
              sx={{
                backgroundColor: `${brandColors[brand].secondary}`,
                fontWeight: "bold",
                color: "white",
              }}
            >
              {t("steps.talkExperts")}
            </DialogTitle>

            <DialogContent
              sx={{
                overflow: "hidden",
                
                width: {
                  xs: "300px", // small screens (mobile)
                  sm: "325px", // tablet
                  md: "325px", // desktop
                },
                height: {
                  xs: "280px", // small screens (mobile)
                  sm: "245px", // tablet
                  md: "245px", // desktop
                },
              }}
            >
              <Grid size={{ xs: 12 }}>
                <Grid
                  sx={{
                    display: "flex",
                    // alignItems: "center",
                    flexDirection: "column",
                    fontWeight: "bold",
                    gap: 2,
                    paddingTop: 2,
                  }}
                >
                  <Typography
                    sx={{ fontWeight: 550, color: "rgba(0,0,0,0.6)" }}
                  >
                    {/* The 24/7 LifeSafer Support Team has the experience and
                    knowledge to assist you with your enrollment. */}
                    {t("steps.readySupport", { brand: brand })}
                  </Typography>
                  <Grid>
                    <Typography
                      sx={{ fontWeight: 550, color: "rgba(0,0,0,0.5)" }}
                    >
                      {t("policies.helpPopupPart2")} {enrolleeUser?.clientId}
                    </Typography>

                    <Typography
                      sx={{
                        paddingTop: 0.5,
                        fontWeight: 550,
                        color: "rgba(0,0,0,0.5)",
                      }}
                    >
                      {t("policies.helpPopupPart3")}
                      <a
                        href={`tel:${t(`brandInfo.brandPhone.${brand}`)}`}
                        style={{
                          color: `${brandColors[brand].primary}`,
                          marginLeft: 5,
                          fontWeight: 400,
                        }}
                      >
                        {t(`brandInfo.brandPhone.${brand}`)}
                      </a>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid size={{ xs: 12 }} style={{ textAlign: "right", paddingTop: 36 }}>
                <Box
                  onClick={handleClose}
                  sx={{
                    color: `${brandColors[brand].primary}`,
                    display: "inline",
                    cursor: "pointer",
                    fontWeight: 500,
                  }}
                >
                  {t("intro.devicePopupButtonLabel").toUpperCase()}
                </Box>
              </Grid>
            </DialogContent>
          </Dialog>
        </Grid>
      </Grid>
    </>
  );
};

ReadyInfo.propTypes = {
  handleUpdate: PropTypes.func,
  goToNextStep: PropTypes.func,
};

export default ReadyInfo;
